import { getMicroserviceBaseContext } from '../../constants/api-routing';

const conversationsContext = getMicroserviceBaseContext('conversations');

export const CONVERSATION_SERVICE = {
    createChatSession: `${conversationsContext}create_chat_session`,
    chstSessionList: `${conversationsContext}chat_session_list/`,
    chatSessionByUserId: `${conversationsContext}get_chat_session_by_user_id`,
    trendingTopicsByUnitCode: `${conversationsContext}business-faq/get_faqs_and_trending_topic`,
    SendChatResponse: `${conversationsContext}create_chat_history`,
    getChatDetails: `${conversationsContext}get_chat_history_by_session_id`,
    getChatSessionGroplist: `${conversationsContext}chat_session_group_list_by_user_id`,
    getChatSessionGroplistRoleplay: `${conversationsContext}chat_session_group_list_by_user_id_scenario_id`,
    createFeedbackMetadata: `${conversationsContext}create_conversation_feedback`,
    getFeedbackMetadata: `${conversationsContext}get_conversation_feedback_by_chat_history_id`,
    updateFeedbackMetadata: `${conversationsContext}update_conversation_feedback_by_history_id`,
    referenceClick: `${conversationsContext}reference_click`,
    deleteChatSession: `${conversationsContext}delete_chat_session`,
    updateChatSession: `${conversationsContext}update_chat_session`,
    getRoleplayChatHistoryBySessionId: `${conversationsContext}get_roleplay_chat_history_by_session_id`,
    getConversationFeedbackMetadataList: `${conversationsContext}get_conversation_feedback_metadata_list`,
    fetchFeedbackWithLogsByUser: `${conversationsContext}fetch_feedback_with_logs_by_user`,
    feedbackWithLogs: `${conversationsContext}feedback_with_logs`,
    fetchFeedbackStatusMetadataList: `${conversationsContext}fetch_feedback_status_metadata_list`,
    botEvalWithFeedback: `${conversationsContext}bot_eval_with_feedback`,
    updateFeedbackActivityLog: `${conversationsContext}activity-log`,
    sourceDocLink: `${conversationsContext}show_source_url`,

}
